import Swiper, { FreeMode, Lazy, Navigation, Pagination, Scrollbar } from 'swiper';
import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/lazy';

import 'swiper/css/navigation';
import 'swiper/css/pagination';

function initializeSliderSustainability(containerId) {
    const containerSlider = $(containerId);

    const slider = new Swiper(containerId + ' .swiper-no-padding', {
        modules: [Navigation, Pagination, Scrollbar, FreeMode, Lazy],

        slidesPerView: 'auto',
        // centerInsufficientSlides: true,

        breakpoints: {
            0: {
                spaceBetween: 8,
                freeMode: false,
            },
            //md
            768: {
                spaceBetween: 24,
                freeMode: true,
            },
        },

        pagination: {
            el: containerId + ' .swiper-pagination',
            type: 'progressbar',
        },

        lazy: {
            enabled: true,
            loadPrevNext: true,
            loadPrevNextAmount: 4,
        },

        navigation: {
            prevEl: containerId + ' .btn-prev',
            nextEl: containerId + ' .btn-next',
        },
        on: {
            init: function () {
                if (this.isLocked) {
                    containerSlider.find('.slider-pager-pager').addClass('hidden');
                }
            },
        },
    });

    slider
        .on('lock', function () {
            containerSlider.find('.slider-pager-pager').addClass('hidden');
        })
        .on('unlock', function () {
            containerSlider.find('.slider-pager-pager').removeClass('hidden');
        });
}

$(function () {
    $('.slider-sustainability').each(function () {
        initializeSliderSustainability('#' + $(this).attr('id'));
    });
});
